
import {instance as axios} from './auth'
import store from '@/store/index'

export function listCategories () {
  let pageSize = 10
  if (store.getters.platform === 'browser') { pageSize = 100 } // no paginamos en web
  let params = {
    'page_size': pageSize
  }
  return axios.get('categories_products/?root=true', {params: params})
}

export function getCategory (id) {
  return axios.get('categories_products/' + id + '/')
}

export function getProduct (id) {
  return axios.get('products/' + id + '/')
}

export function getCart () {
  return axios.get('cart/')
}

export function addProductToCart (data) {
  return axios.post('products_cart/', data)
}

export function removeFromCart (id) {
  return axios.delete('products_cart/' + id + '/')
}

export function putFromCart (id, params) {
  return axios.put('products_cart/' + id + '/', params)
}

export function paginate (url) {
  return axios.get(url)
}

export function purchaseSumary (data) {
  return axios.post('purchases/summary/', data)
}

export function makePurchase (data) {
  return axios.post('purchases/', data)
}

export function makeDirectPurchase (data) {
  return axios.post('purchases/direct_purchase/', data)
}

/* TIENDA A2C */
export function categoriesA2C (data) {
  let params = {
    'params': 'force_all',
    'count': 250
  }
  params = { ...data, ...params }
  return axios.get('shop/category/', {params: params, headers: {'Authorization': 'Bearer ' + store.getters.getToken}})
}

export function productsA2C (data) {
  let params = {
    'params': 'force_all',
    'count': 250,
    'avail_view': true,
    'avail_sale': true
  }
  params = { ...data, ...params }
  return axios.get('shop/products/', {params: params, headers: {'Authorization': 'Bearer ' + store.getters.getToken}})
}

export function getCombinations (data) {
  // no podemos filtrar por avail_sale = true porque no podríamos saber si el produccto no esta disponible
  let params = {
    'params': 'force_all'
  }

  params = { ...data, ...params }
  return axios.get('shop/childs/', {params: params, headers: {'Authorization': 'Bearer ' + store.getters.getToken}})
}

export function setOrderA2C (data) {
  return axios.post('shop/order/', data, {headers: {'Authorization': 'Bearer ' + store.getters.getToken}})
}

export function getOrderA2C (data) {
  let params = {
    'params': 'force_all'
  }
  params = { ...data, ...params }
  return axios.get('shop/order/', {params: params, headers: {'Authorization': 'Bearer ' + store.getters.getToken}})
}

export function makePurchaseA2C (data) {
  return axios.post('shop/payment/', data, {headers: {'Authorization': 'Bearer ' + store.getters.getToken}})
}

export function addProductToCartA2C (data) {
  return axios.post('shop/cart/', data, {headers: {'Authorization': 'Bearer ' + store.getters.getToken}})
}

export function getCartA2C () {
  return axios.get('shop/cart/', {headers: {'Authorization': 'Bearer ' + store.getters.getToken}})
}

export function removeFromCartA2C (id) {
  return axios.delete('shop/cart/' + id + '/', {headers: {'Authorization': 'Bearer ' + store.getters.getToken}})
}

export function cartProcessA2C (data) {
  return axios.post('shop/cart/process/', data, {headers: {'Authorization': 'Bearer ' + store.getters.getToken}})
}



// WEBPACK FOOTER //
// ./src/services/products.js